import { faFileContract } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import ReactComponent from '@/components/ReactComponent';
import MeioJulgamentoProcesso, { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import fileDownload from 'js-file-download';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

class DownloadAta extends ReactComponent {
    anchorElDownloadAta = null;
    openMenuDownloadAta = Boolean(this.anchorElDownloadAta);

    #codigosTipoJulgamentoVirtual = [MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo];
    #codigosTipoJulgamentoPresencial = [
        MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo,
        MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.codigo
    ];
    #codigosTipoJulgamentoVirtualPresencial = [
        MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo,
        MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo,
        MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.codigo
    ];

    constructor(props) {
        super(props);

        makeObservable(this, {
            anchorElDownloadAta: observable,
            openMenuDownloadAta: observable,
            handleClickMenu: action,
            handleCloseMenu: action,
            temProcessosPresenciais: computed,
            temProcessosVirtuais: computed
        });
    }

    handleClickMenu = (event) => {
        this.anchorElDownloadAta = event.currentTarget;
        this.openMenuDownloadAta = true;
    };

    handleCloseMenu = () => {
        this.anchorElDownloadAta = null;
        this.openMenuDownloadAta = false;
    };

    get temProcessosPresenciais() {
        return this.sessaoStore.processosSessao.some((processo) =>
            this.#codigosTipoJulgamentoPresencial.includes(processo.tipoJulgamento)
        );
    }

    get temProcessosVirtuais() {
        return this.sessaoStore.processosSessao.some((processo) =>
            this.#codigosTipoJulgamentoVirtual.includes(processo.tipoJulgamento)
        );
    }

    downloadAta(tipoJulgamento) {
        let promise = this.sessaoService.gerarAta(this.sessaoStore.idSessaoSelecionada, tipoJulgamento);
        promise.then((response) => {
            fileDownload(response, 'ata_' + this.sessaoStore.idSessaoSelecionada + '.html', 'text/html');
        });
        this.handleCloseMenu();
    }

    render() {
        const menuId = 'download-ata-menu';
        const { cursor, pointerEvents } = this.observableProps;

        return (
            <>
                <Tooltip
                    title={'Gerar ata da sessão'}
                    placement="top-start"
                >
                    <div
                        style={{ display: 'flex', cursor: cursor, fill: 'white' }}
                        className="corBotaoAmarelo"
                    >
                        <FontAwesomeIcon
                            data-testid="abrirMenuDownloadAta"
                            icon={faFileContract}
                            onClick={this.handleClickMenu}
                            style={{
                                pointerEvents,
                                cursor,
                                width: '24px',
                                height: '22px',
                                margin: '8px'
                            }}
                        />
                    </div>
                </Tooltip>
                <Menu
                    id={menuId}
                    anchorEl={this.anchorElDownloadAta}
                    open={this.openMenuDownloadAta}
                    onClose={this.handleCloseMenu}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    sx={{ mt: 1 }}
                >
                    {this.temProcessosVirtuais && (
                        <MenuItem
                            onClick={() => this.downloadAta(this.#codigosTipoJulgamentoVirtual)}
                            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                            divider={this.temProcessosPresenciais}
                        >
                            {MeioJulgamentoProcesso.getIconesLista(this.#codigosTipoJulgamentoVirtual)}
                            <Typography>Apenas da sessão virtual</Typography>
                        </MenuItem>
                    )}
                    {this.temProcessosPresenciais && (
                        <MenuItem
                            onClick={() => this.downloadAta(this.#codigosTipoJulgamentoPresencial)}
                            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                            divider={this.temProcessosVirtuais}
                        >
                            {MeioJulgamentoProcesso.getIconesLista(this.#codigosTipoJulgamentoPresencial)}
                            <Typography>Apenas da sessão presencial</Typography>
                        </MenuItem>
                    )}
                    {this.temProcessosVirtuais && this.temProcessosPresenciais && (
                        <MenuItem
                            onClick={() => this.downloadAta(this.#codigosTipoJulgamentoVirtualPresencial)}
                            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                        >
                            {MeioJulgamentoProcesso.getIconesLista(this.#codigosTipoJulgamentoVirtualPresencial)}
                            <Typography>Ambas (virtual e presencial)</Typography>
                        </MenuItem>
                    )}
                </Menu>
            </>
        );
    }
}

export default inject('stores')(observer(DownloadAta));
